<template>
  <a-layout-content>
    <s-banner></s-banner>
    <div class="keyperson-content">
      <a-breadcrumb style="">
        <a-breadcrumb-item>{{`${$route.name=='buyer'?'我的采购商':'我的展会名录'}`}}</a-breadcrumb-item>
      </a-breadcrumb>
      <a-form layout="inline" class="search">
        <a-form-item label="公司名称" >
          <a-input placeholder='请输入公司名称' size="small" style="width: 160px" v-model="searchCompany">
          </a-input>
        </a-form-item>
        <a-form-item>
        <a-cascader :options="options" placeholder="请选择国家" @change="onChange" size="small" :show-search="{ filter }"/>
        </a-form-item>
        <a-form-item>
          <a-button type='primary' size="small" @click="search"> 搜索 </a-button>
        </a-form-item>
        <a-form-item class="export-button" style="float:right;margin-right:0px">
          <a-button size="small" @click="exportExcel" ><span class="export"></span><span style="color:#fa982c">导出</span> </a-button>
        </a-form-item>
      </a-form>

      <s-table :data="loadData" ref="table" :showSizeChanger="false" :pageSize="10">
        <a-table-column title="序号" dataIndex="index"></a-table-column>
        <a-table-column title="公司名称" > 
          <span slot-scope="text, record">
            <span v-html="record.company"></span>
          </span>
        </a-table-column>
        <a-table-column title="地区" dataIndex="country"> </a-table-column>
        <a-table-column title="操作" dataIndex="action">
          <span slot-scope="text, record">
            <a :href="`/buyerfinder/detail/${record.id}?type=${record.type}`" @click_="detail(record.id)">查看</a>
          </span>
        </a-table-column>
      </s-table>
    </div>
  </a-layout-content>
</template>

<script>
import Banner from "./banner";
import ExportExcel from "../ExportExcel";
export default {
  data() {
    return {
      searchConutryId:0,
      searchCompany:'',
      options:[
      ],
      html:null,
    };
  },
  components: { "s-banner": Banner },
  methods: {
    filter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    onChange(value) {
      this.searchConutryId=value&&value.length&&value[0];
      console.log(value);
    },
    search() {
      this.$refs.table.refresh();
    },
    detail(pid) {
      this.$router.push({ name: "buyerdetail", params: { pid }, query: { plan: 'private' }});
    },
    exportExcel(){
      return this.$dialog(ExportExcel, {
          type: this.$route.name=="buyer"?1:2
        });
    },
    loadData(p) {
      console.log(this.$route)
      return this.$http
        .post("/zzCollectListPurchaser", {
          pageNo: (p && p.pageNo) || 1,
          pageSize: 10,
          company: this.searchCompany,
          type:this.$route.name=="buyer"?1:2,
          country_id:this.searchConutryId
        })
        .then(res => {
          if (!res.error) {
            console.log(res)
            let html=document.createElement("div");
            var a = {
              pageNo: parseInt(res.pageNo),
              totalCount: parseInt(res.totalCount),
              result: res.data.list.map((d, i) => {
                d.index = (parseInt(res.pageNo) - 1) * p.pageSize + i + 1;
                d.type=(this.$route.name=="buyer"?1:4);
                html.innerHTML=d.company;
                d.company=html.innerText;
                return d;
              }).filter(m=>m.id)
            };
            html=null;
            this.pageNo=parseInt(res.pageNo);
            return a;
          }
        });
    }
  },
  created() {
    this.$http.post("/zzCountryList").then(res => {
        if (!res.error) {
          this.options = res.data&&res.data.countryList&&res.data.countryList.map(m=>{return {
            value:m.id,
            label:m.cnname
          }})||[];
        }
    });
  },
  watch:{
    $route(n,o){
      if(n.name!=o.name){
        this.searchConutryId=0;
        this.searchCompany="";
        this.$refs.table.localPagination.current=1
        this.$refs.table.refresh();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.keyperson-content {
  min-height: 750px;
  & /deep/ .ant-breadcrumb {
    margin: 16px 0;
    font-size: 18px;
    color: #333;
    font-weight: bold;
  }
  .search {
    & /deep/ .ant-form-item-label label {
      font-size: 13px;
      color: #999;
    }
    & /deep/ .ant-form-item-children {
      & .ant-btn,
      & .ant-input,
      & .ant-select-selection {
        font-size: 13px;
        border-radius: 0;
      }
    }
  }
  & /deep/ .ant-table-body {
    border-top: 1px solid #dcdcdc;
    border-radius: 0;
    .ant-table-thead {
      & > tr > th {
        padding: 8px 16px;
      }
    }

    .ant-table-tbody {
      tr {
        &:nth-child(even) {
          background: #f8fdff;
        }
        td {
          padding: 9px 16px;
        }
      }
    }
  }
  & /deep/ .ant-table-pagination {
    float: none;
  }
  .export-button{
    margin-left: 40px;
    .export{
      color:#fa982c;
      display: inline-block;
      width: 20px;
      height: 16px;
      background: url("~@/assets/img/export.png") no-repeat;
      background-color:#fff9f3;
      margin:auto 0;
    }
    .ant-btn{
          border-color:#fdd3a5;
          padding: 0px 20px;
          border-radius: 4px !important;
          height:26px;
    }
    & /deep/ .ant-btn:link, .ant-btn:visited{
        border-color: #fdd3a5 !important;
    }
    & /deep/ .ant-btn:hover, .ant-btn:focus{
        color:#fa982c !important;
        border-color: #fa982c !important;
    }
  }
}
</style>